// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scroll-to-top{background-color:rgba(0,0,0,.3);border-radius:50%;bottom:20px;cursor:pointer;display:block;height:70px;opacity:0;position:fixed;right:20px;transition:all .3s ease;width:70px;z-index:2}.scroll-to-top--show{opacity:1}.scroll-to-top__row{border:solid #fff;border-width:2px 0 0 2px;left:28px;margin-top:32px;padding:6px;position:absolute;transform:rotate(45deg)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
